import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createButtonBlock,
  createH1Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { getColorOptions } from "../../../../utils/textStyleHelpers";
import { primaryBlockDefaultStyles } from "../../constants";
import placeholderImage from "./homepage_block_1_placeholder.png";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "ProfessionalNetworkHomepageBlock1",
  props: {
    leftContent: {
      meta: {
        name: "Left Content",
        nameI18n: "builder_ui.prop_type.left_content",
      },
      prop: "children",
      type: "children",
      value: [
        createH1Block({
          text: "Lead, learn, and grow — together",
          styles: {
            color: getColorOptions("var(--theme-website-color-1)"),
          },
        }),
        createPBlock({
          text: "Build meaningful connections inside a trusted professional network. Share knowledge, exchange ideas, and develop your expertise with the support of a community that values growth, leadership, and impact.",
          styles: {
            color: getColorOptions("var(--theme-website-color-1)"),
          },
        }),
      ],
    },
    rightContent: {
      meta: {
        name: "Right Content",
        nameI18n: "builder_ui.prop_type.right_content",
      },
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: placeholderImage,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                maxHeight: "none",
                maxWidth: "none",
                width: "100%",
                height: "100%",
                minHeight: "auto",
                minWidth: "auto",
              },
            }),
          },
        }),
      ],
    },
    buttons: {
      meta: {
        name: "Buttons",
        nameI18n: "builder_ui.prop_type.buttons",
      },
      prop: "children",
      type: "children",
      value: [
        createButtonBlock({
          text: "Book a free session",
          href: "#",
          buttonType: "secondaryButton",
        }),
        createButtonBlock({
          text: "Join the community",
          href: "#",
          buttonType: "customButton",
          styles: {
            default: {
              color: getColorOptions(
                "var(--theme-website-primary-button-default-text-color)",
              ),
              backgroundColor: getBackgroundColorOptions({
                defaultValue: "transparent",
              }),
            },
          },
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: "var(--theme-website-color-6)",
        }),
        padding: getPaddingOptions({
          defaultValue: {
            paddingTop: "0",
            paddingRight: "0",
            paddingBottom: "0",
            paddingLeft: "0",
          },
        }),
        margin: getMarginOptions({
          defaultValue: primaryBlockDefaultStyles.margin,
        }),
      },
      meta: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        category: [],
      },
    },
  },
};
